import React, { useEffect } from "react";

const RedirectToGames: React.FC = () => {
  useEffect(() => {
    window.location.replace("https://games.entornobiai.com");
  }, []);

  return null;
};

export default RedirectToGames;
